export const registrationRoutes = {
  identity: {
    path: '/inscription/identite',
    name: 'identity-form',
    component: () => import('@/components/pages/registration/IdentityFormPage.vue'),
    meta: { requireAuth: true, changeCookiePosition: true }
  },
  establishment: {
    path: '/inscription/etablissement',
    name: 'establishment-form',
    component: () => import('@/components/pages/registration/EstablishmentFormPage.vue'),
    meta: { requireAuth: true, changeCookiePosition: true }
  },
  documents: {
    path: '/inscription/documents',
    name: 'documents-form',
    component: () => import('@/components/pages/registration/DocumentsFormPage.vue'),
    meta: { requireAuth: true, changeCookiePosition: true }
  },
  size: {
    path: '/inscription/tailles',
    name: 'sizes-form',
    component: () => import('@/components/pages/registration/SizesFormPage.vue'),
    meta: { requireAuth: true, changeCookiePosition: true }
  },
  recipe: {
    path: '/inscription/recette',
    name: 'recipe-form',
    component: () => import('@/components/pages/registration/RecipeFormPage.vue'),
    meta: { requireAuth: true, changeCookiePosition: true }
  },
  about: {
    path: '/inscription/a-propos',
    name: 'about-form',
    component: () => import('@/components/pages/registration/AboutFormPage.vue'),
    meta: { requireAuth: true, changeCookiePosition: true }
  },
  end: {
    path: '/inscription/confirmation',
    name: 'end-form',
    component: () => import('@/components/pages/registration/EndPage.vue'),
    meta: { requireAuth: true, changeCookiePosition: true }
  }
};
